import { render, staticRenderFns } from "./AdvertComp.vue?vue&type=template&id=36c7d58e&scoped=true"
import script from "./AdvertComp.vue?vue&type=script&lang=js"
export * from "./AdvertComp.vue?vue&type=script&lang=js"
import style0 from "./AdvertComp.vue?vue&type=style&index=0&id=36c7d58e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36c7d58e",
  null
  
)

export default component.exports